import is from 'is_js';
import IconRepeat from '../assets/images/fa-repeat.svg';
import IconHourglass from '../assets/images/fa-hourglass.svg';
import IconMapMarker from '../assets/images/fa-map-marker.svg';

export const ICON_CTA_ADD = '/images/cta-add.svg';
export const ICON_CTA_WEBSITE = '/images/cta-website.svg';
export const ICON_CTA_CALL = '/images/cta-call.svg';
export const ICON_CTA_EMAIL = '/images/cta-email.svg';
export const ICON_CTA_OWN_ANCHOR = '/images/cta-bookmark.svg';
export const ICON_CTA_TRIGGER = '/images/cta-trigger.svg';
export const ICON_CTA_CUSTOM = '/images/cta-custom.svg';
export const ICON_JOIN_SEGMENT = '/images/join-audience.svg';
export const ICON_CTA_CONTENT = '/images/cta-content.svg';
export const ICON_CTA_NOTIFICATION = '/images/cta-notification.png';
export const ICON_CTA_ACTIVATE_BROADCAST = '/images/cta-activate-broadcast.svg';
export const TRASH_BIN = '/images/trash-bin.svg';

let imgDragBookmark = '/images/drag-preview/drag-bookmark.svg';
let imgDragCustom = '/images/drag-preview/drag-custom.svg';
let imgDragEmail = '/images/drag-preview/drag-email.svg';
let imgDragCall = '/images/drag-preview/drag-call.svg';
let imgDragImage = '/images/drag-preview/drag-image.svg';
let imgDragNotification = '/images/drag-preview/drag-notification.png';
let imgDragPdf = '/images/drag-preview/drag-pdf.svg';
let imgDragTrigger = '/images/drag-preview/drag-trigger.svg';
let imgDragVideo = '/images/drag-preview/drag-video.svg';
let imgDragWebsite = '/images/drag-preview/drag-website.svg';
let imgDragJoinSegment = '/images/drag-preview/drag-join-audience.svg';
let imgDragActivateBroadcast = '/images/drag-preview/drag-activate-broadcast.svg';

if (is.safari() || is.ie()) {
  imgDragBookmark = '/images/drag-preview/drag-bookmark.png';
  imgDragCustom = '/images/drag-preview/drag-custom.png';
  imgDragEmail = '/images/drag-preview/drag-email.png';
  imgDragCall = '/images/drag-preview/drag-call.png';
  imgDragImage = '/images/drag-preview/drag-image.png';
  imgDragNotification = '/images/drag-preview/drag-notification.png';
  imgDragPdf = '/images/drag-preview/drag-pdf.png';
  imgDragTrigger = '/images/drag-preview/drag-trigger.png';
  imgDragVideo = '/images/drag-preview/drag-video.png';
  imgDragWebsite = '/images/drag-preview/drag-website.png';
  imgDragJoinSegment = '/images/drag-preview/drag-join-audience.png';
  imgDragActivateBroadcast = '/images/drag-preview/drag-activate-broadcast.png';
}

// Dragging preview
export const DRAGGING_BOOKMARK = imgDragBookmark;
export const DRAGGING_CUSTOM = imgDragCustom;
export const DRAGGING_EMAIL = imgDragEmail;
export const DRAGGING_CALL = imgDragCall;
export const DRAGGING_IMAGE = imgDragImage;
export const DRAGGING_NOTIFICATION = imgDragNotification;
export const DRAGGING_PDF = imgDragPdf;
export const DRAGGING_TRIGGER = imgDragTrigger;
export const DRAGGING_VIDEO = imgDragVideo;
export const DRAGGING_WEBSITE = imgDragWebsite;
export const DRAGGING_JOIN_SEGMENT = imgDragJoinSegment;
export const DRAGGING_ACTIVATE_BROADCAST = imgDragActivateBroadcast;

export const ICON_CLOSE = '/images/ico-close.svg';

export const ICON_REPEAT = IconRepeat;
export const ICON_HOURGLASS = IconHourglass;
export const ICON_MAP_MARKER = IconMapMarker;



// WEBPACK FOOTER //
// ./src/constants/ImagesUrl.js